import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, QueryParameterState, addQueryParam, changeQueryParams, getCountryNameByCode } from 'src/api';
import { RouterState } from 'connected-react-router';
import { Icon } from '../../Images';

import { FormattedMessage } from 'react-intl';
import { isoDetails, isoDetailsArray, getValueFromPricings } from 'franke-trough-dependencies';

export interface PricingSwitchViewProps {
  dispatch: any;
  pricing: GlobalPrivateState['pricing'];
  pricings: GlobalPrivateState['pricings'];
  location: RouterState['location'];
  params: QueryParameterState['params'];
  user: GlobalPrivateState['user'];
}

export class PricingSwitchViewPartial extends React.Component<PricingSwitchViewProps> {

  constructor(props: PricingSwitchViewProps) {
    super(props);
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  public render() {
    const { pricings } = this.props;
    const marketPricings = pricings.result && pricings.result.filter(p => p.type === 'market' && !p.deleted) || [];
    const selectedGroupKey: any = this.props.params.groupKey || 'DE';
    const tabs: {id: string, label: string, countries: string[]}[] = []; 

    for (const marketPricing of marketPricings) {
      const priceList = getValueFromPricings(marketPricing, 'price_list');
      const existingTab = tabs.find(t => t.id === priceList);
			const countryCode = getValueFromPricings(marketPricing, 'country');
			const countryName = getCountryNameByCode(countryCode) || '';

      if (!existingTab) {
        tabs.push({id: priceList, label: priceList, countries: [countryName]});
      } else {
				existingTab.countries = [...existingTab.countries, countryName];
			}
    }

		const selectedTab = tabs.find(t => t.id === selectedGroupKey);

    return (
      <div className={[
        "partial-pricing-switch-view", 
        this.props.pricing.updating ? "updating" : ""
      ].join(' ')}>
				<ul className={`list list-tabswitch list-unstyled float-left`}>
					{tabs.map((tab) => {
						return (
							<li className="d-inline-block" key={'tab'+tab.id}>
								<button
									disabled={selectedGroupKey === tab.id}
									onClick={(ev) => this.handleTabClick(ev, tab.id)}
									className={`btn btn-link p-0 ${selectedGroupKey === tab.id ? 'active' : ''}`}
								>
									{tab.label}
								</button>
							</li>
						)
					})}
				</ul>
      </div>
    );
  }

  private handleTabClick(event: React.MouseEvent, type: any) {
    const { groupKey } = this.props.params;
    if (groupKey !== type) {
      this.props.dispatch(changeQueryParams({
        ...this.props.params,
        groupKey: type
      }));
    }
  }
}

export const PricingSwitchView = connect((state: GlobalPrivateState) => ({
  pricing: state.pricing,
  pricings: state.pricings,
  location: state.router.location,
  params: state.queryState.params,
  user: state.user,
}))(PricingSwitchViewPartial);

export default PricingSwitchView;
